import React from 'react';
import { View } from 'react-native';

import { ViewPropTypes } from 'deprecated-react-native-prop-types';
import { isFunction as _isFunction } from 'lodash';
import PropTypes from 'prop-types';

import { Shimmer } from '@vfgroup-oneplatform/foundation/Components';
import { shimmerPlaceholderConfig } from '@vfgroup-oneplatform/foundation/Components/Shimmer/Shimmer.utils';

import { headerLineLoadingConfig } from './HeaderLoadingConfig';
import styles from './HeaderLoadingStyles';

const HeaderLoading = ({
  renderRightComponent,
  firstLineStyle,
  secondLineStyle,
  lastLineStyle,
  containerStyle,
}) => {
  return (
    <View style={[styles.headerShimmerContainerStyle, containerStyle]}>
      <View style={styles.shimmerContainerWidth}>
        {!!firstLineStyle && (
          <Shimmer
            config={headerLineLoadingConfig(firstLineStyle)}
            shimmerPlaceholderConfig={shimmerPlaceholderConfig}
          />
        )}
        {!!secondLineStyle && (
          <Shimmer
            config={headerLineLoadingConfig(secondLineStyle)}
            shimmerPlaceholderConfig={shimmerPlaceholderConfig}
          />
        )}
        {!!lastLineStyle && (
          <Shimmer
            config={headerLineLoadingConfig(lastLineStyle)}
            shimmerPlaceholderConfig={shimmerPlaceholderConfig}
          />
        )}
      </View>
      {_isFunction(renderRightComponent) && renderRightComponent()}
    </View>
  );
};
HeaderLoading.propTypes = {
  renderRightComponent: PropTypes.func,
  firstLineStyle: ViewPropTypes.style,
  lastLineStyle: ViewPropTypes.style,
  secondLineStyle: ViewPropTypes.style,
  containerStyle: ViewPropTypes.style,
};

export default HeaderLoading;
